import { useEffect } from 'react';
import SharedHeader from '../../components/feature/SharedHeader';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SharedHeader />
      
      <main className="max-w-[900px] mx-auto px-6 lg:px-8 py-20">
        <h1 className="text-[42px] font-bold text-[#111111] mb-4">Privacy Policy</h1>
        <p className="text-[14px] text-[#666666] mb-12">
          <strong>Effective Date:</strong> January 2025
        </p>

        <div className="space-y-10">
          {/* Section 1 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">1. Information We Collect</h2>
            <p className="text-[15px] text-[#333333] leading-relaxed mb-3">
              We may collect:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[15px] text-[#333333] leading-relaxed">
              <li>Name</li>
              <li>Email address</li>
              <li>Company information</li>
              <li>Any message submitted via contact form</li>
              <li>Basic website usage data (analytics, cookies)</li>
            </ul>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">2. How We Use Information</h2>
            <p className="text-[15px] text-[#333333] leading-relaxed mb-3">
              We use personal data to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[15px] text-[#333333] leading-relaxed">
              <li>Respond to inquiries</li>
              <li>Provide information about our advisory services</li>
              <li>Improve website functionality</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">3. Legal Basis</h2>
            <p className="text-[15px] text-[#333333] leading-relaxed">
              We process data based on legitimate interest, consent (where applicable), and contractual necessity.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">4. Data Storage</h2>
            <p className="text-[15px] text-[#333333] leading-relaxed">
              Information may be stored securely on third-party hosting providers. We take reasonable measures to protect data against unauthorized access.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">5. Third-Party Services</h2>
            <p className="text-[15px] text-[#333333] leading-relaxed">
              We may use analytics tools and hosting providers. These providers may process limited technical data.
            </p>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">6. International Transfers</h2>
            <p className="text-[15px] text-[#333333] leading-relaxed">
              As we operate internationally, data may be processed outside your jurisdiction.
            </p>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">7. Your Rights</h2>
            <p className="text-[15px] text-[#333333] leading-relaxed">
              You may request access, correction or deletion of your personal data by contacting us at:{' '}
              <a 
                href="mailto:info@precious-leader-trade.com" 
                className="text-[#B11226] hover:underline"
              >
                info@precious-leader-trade.com
              </a>
            </p>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">8. Changes</h2>
            <p className="text-[15px] text-[#333333] leading-relaxed">
              We may update this policy periodically.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}